import { useEffect, useState } from 'react';

export default function FloatingCallButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Slide up animation on mount
    setTimeout(() => setIsVisible(true), 300);
  }, []);

  return (
    <a
      href="tel:0416497716"
      className={`fixed bottom-6 right-6 lg:hidden z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
      aria-label="Call Now"
    >
      {/* Pulse animation ring */}
      <div className="absolute inset-0 bg-[#f67f19] rounded-full animate-ping opacity-75"></div>
      
      {/* Main button */}
      <div className="relative bg-[#f67f19] hover:bg-[#e06e0a] text-white rounded-full shadow-2xl flex items-center gap-2 px-5 py-4 transition-all transform hover:scale-105 cursor-pointer">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-phone-fill text-xl"></i>
        </div>
        <span className="font-bold text-sm whitespace-nowrap">Call Now</span>
      </div>
    </a>
  );
}